/* lib/reportsSection.js — рубильник раздела «Отчёты» (№524, решение Данилы 04.11.2026).

   К релизу 11.11 раздел убран из интерфейса: пункт меню (сайдбар, таб-бар), поиск,
   шаг онбординга, ссылки «Открыть отчёт» в карточках старых чатов и в уведомлениях;
   прямые адреса /reports уводят к Ассистенту (app/routes.jsx). Сохранённые отчёты
   не удалены. Вернуть раздел — true здесь и REPORT_SKILLS_ENABLED=True на бэкенде
   (скиллы отчётов в чате, chats/report_skills.py). */
export const REPORTS_SECTION_ENABLED = false;

// Слаги скиллов отчётов — зеркало chats/report_skills.REPORT_SKILL_SLUGS.
export const REPORT_SKILL_SLUGS = ['foodcost-optimize', 'abc-analyze', 'inventory-analyze'];

/** Адрес отчёта или null, пока раздел выключен (ссылку не показываем). */
export function reportHref(id) {
  return REPORTS_SECTION_ENABLED && id != null ? `/reports/${id}` : null;
}

/** Скиллы для карточек и поиска: без отчётов, пока раздел выключен. */
export function withoutReportSkills(skills) {
  if (REPORTS_SECTION_ENABLED || !Array.isArray(skills)) return skills;
  return skills.filter((s) => !REPORT_SKILL_SLUGS.includes(s && s.slug));
}
